import useSWR from "swr";
import { apiBaseURL } from "../../Utils/ProjectConstants";

export default function useGetSupplierList() {
  const { data, error, mutate, isLoading } = useSWR(
    `${apiBaseURL}/api/suppliers`,
    {
      //onSuccess: (data) => console.log('delivery locations fetched successfully:', data?.data),
      revalidateOnFocus: false,
      dedupingInterval: 300000,
    }
  );

  const supplierList = data?.data;

  return {
    supplierList,
    isLoading,
    error,
    mutate,
  };
}
